import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useCycleCountApi() {
  const callApi = useApiCall();

  const GetByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_BY_ID, data, onSuccess, onError);
  }

  const GetByPartName = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_BY_PART_NAME, data, onSuccess, onError);
  }

  const GetList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.LIST, data, onSuccess, onError);
  }

  const Save = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.SAVE, data, onSuccess, onError);
  }

  const Delete = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.DELETE, data, onSuccess, onError);
  }

  const ExportToPdf = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.EXPORT_TO_PDF, data, onSuccess, onError);
  }

  const ExportToXls = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.EXPORT_TO_XLS, data, onSuccess, onError);
  }

  const GetID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_ID, data, onSuccess, onError);
  }

  const GetStockPicking = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_PICKING, data, onSuccess, onError);
  }

  const AddStockPicking = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.ADD_STOCK_PICKING, data, onSuccess, onError);
  }
  const GetStockCount = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.STOCK_COUNT, data, onSuccess, onError);
  }

   const GetStockPickingList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_COUNT_PICKING, data, onSuccess, onError);
  }

    const GetStockPickingDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_PICKING_DETAILS, data, onSuccess, onError);
  }
  const GetStockPickingByPart= (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_PICKING_BY_PART, data, onSuccess, onError);
  }
  const ExportPickingToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.EXPORT_PICKING_TO_XLS, data, onSuccess, onError);
  }

  const ExportPickingToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.EXPORT_PICKING_TO_PDF, data, onSuccess, onError);
  }
  const SaveStockReturn = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.SAVE_STOCK_RETURN, data, onSuccess, onError);
  }

  return {
    GetByID ,
    GetByPartName ,
    GetList ,
    Save ,
    Delete ,
    ExportToPdf ,
    ExportToXls ,
    GetID ,
    GetStockPicking ,
    AddStockPicking,
    GetStockCount,
    GetStockPickingList,
    GetStockPickingDetails,
    GetStockPickingByPart,
    ExportPickingToXLS,
    ExportPickingToPDF,
    SaveStockReturn
  };
}
